import { cn } from "@lib/cn";
import { IconCheck } from "@tabler/icons-react";
import { useFileToStorydocStoreShallow } from "../stores";
import { trackImportPreJob } from "../utils/track-import";

export const PageThumbnailGrid = ({ atCap }: { atCap: boolean }) => {
  const { pages, togglePage } = useFileToStorydocStoreShallow((s) => ({
    pages: s.pages,
    togglePage: s.togglePage,
  }));

  return (
    <div className="tw-grid tw-grid-cols-4 tw-gap-4">
      {pages.map((page) => {
        const blocked = atCap && !page.selected;
        return (
          <button
            type="button"
            key={page.pageNumber}
            aria-label={`Page ${page.pageNumber}`}
            aria-pressed={page.selected}
            aria-disabled={blocked}
            onClick={() => {
              if (blocked) return;
              togglePage(page.pageNumber);
              trackImportPreJob("page toggled", {
                pageNumber: page.pageNumber,
                selected: !page.selected,
              });
            }}
            className={cn(
              "tw-relative tw-aspect-video tw-w-full tw-overflow-hidden tw-rounded-lg tw-bg-blue-50 tw-shadow-2xs tw-outline tw-outline-1 tw-outline-offset-0 tw-outline-blue/5",
              page.selected &&
                "tw-outline-2 -tw-outline-offset-2 tw-outline-violet-700",
              blocked && "tw-cursor-not-allowed tw-opacity-40",
            )}
          >
            <img
              src={page.thumbnailUrl}
              alt={`Page ${page.pageNumber} preview`}
              className="tw-size-full tw-object-cover"
            />
            <span
              className={cn(
                "tw-absolute tw-right-1 tw-top-1 tw-flex tw-size-4 tw-items-center tw-justify-center tw-rounded tw-bg-white tw-shadow-xs tw-outline tw-outline-1 tw-outline-blue/5",
                page.selected && "tw-bg-violet-700",
              )}
            >
              <IconCheck className="tw-size-3 tw-text-white" />
            </span>
          </button>
        );
      })}
    </div>
  );
};
